<template>
  <div id="div-with-loading" class="vs-con-loading__container">
    <div
      style="display: flex; align-items: center; justify-content: space-between"
    >
      <h2 class="mt-2 p-3" style="font-weight: 600">
        Electric Potential Graph
      </h2>
      <div style="margin-right: 10px; display: flex; gap: 10px">
        <vs-select
          class="selectExample"
          width="120px"
          v-model="select2"
          @change="selectChart"
        >
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in options_plan"
          />
        </vs-select>
        <!-- <vs-select
          class="selectExample"
          width="120px"
          v-model="select1"
          @change="selectChart"
        >
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in options_graph"
          />
        </vs-select> -->
      </div>
    </div>
    <!-- <div id="stock-chart-1"></div> -->
    <stock-chart :chart="chart" v-if="chart.series.length > 0" />
  </div>
</template>

<script>
import Highcharts from "highcharts/highstock";
import Exporting from "highcharts/modules/exporting";
import ExportData from "highcharts/modules/export-data";
import StockChart from "@/components/HighChart/StockChart.vue";

Exporting(Highcharts);
ExportData(Highcharts);

export default {
  components: {
    StockChart,
  },
  props: {},
  data() {
    return {
      select1: "month",
      options_graph: [
        // { text: "Day", value: "day" },
        { text: "Month", value: "month" },
        { text: "Year", value: "Year" },
      ],
      select2: "um",
      options_plan: [
        { text: "UM", value: "um" },
        { text: "JP", value: "jp" },
      ],
      dataChart: {},
      stockChart: null,
      chart: {
        chart: {
          backgroundColor: "transparent",
        },
        rangeSelector: {
          buttons: [
            // {
            //   type: "hour",
            //   count: 3,
            //   text: "3h",
            // },
            {
              type: "hour",
              count: 6,
              text: "6h",
            },
            {
              type: "hour",
              count: 12,
              text: "12h",
            },
            {
              type: "day",
              count: 1,
              text: "1D",
            },
            {
              type: "day",
              count: 7,
              text: "1W",
            },
            {
              type: "month",
              count: 1,
              text: "1m",
            },
            {
              type: "all",
              count: 1,
              text: "All",
            },
          ],
          selected: 2,
          inputEnabled: true,
          enabled: true,
        },
        colors: ["#cc7400", "#00cc7e", "#da2acb"],
        title: {
          // text: "Vibration Sensor Graph",
          align: "left",
          style: {
            color: "#808080",
            fontSize: "18px",
            "font-weight": "900",
          },
        },

        series: [],
      },
      interval: null,
    };
  },
  async mounted() {
    console.log("");
    this.$vs.loading({
      container: "#div-with-loading",
      scale: 0.6,
    });
    await this.getDataChart();

  },
  beforeDestroy() {
  },
  methods: {
    async getDataChart() {
      try {
        let res = await this.$API.get("ajino-get-dashbooard-electric");
        console.log(
          "dashbooard-electric",
          res.data.message.electric_potential_graph
        );
        this.dataChart = res.data.message.electric_potential_graph;

        this.selectChart();
        this .$vs.loading.close("#div-with-loading > .con-vs-loading");
      } catch (error) {
        console.log(error);
        this.$vs.loading.close("#div-with-loading > .con-vs-loading");
      }
    },
    selectChart() {
      console.log(this.select2, this.select1);
      console.log(this.dataChart[this.select2][this.select1].Phase_1);
      // const datasets = this.dataChart[this.select2][this.select1];
      // const data = datasets[this.select1];
      // const Phase_1 = this.dataChart[this.select2][this.select1].Phase_1;
      // const Phase_2 = this.dataChart[this.select2][this.select1].Phase_2;
      // const Phase_3 = this.dataChart[this.select2][this.select1].Phase_3;
      // console.log(Phase_1, Phase_2, Phase_3);

      let Phase = {
        Phase_1: [],
        Phase_2: [],
        Phase_3: [],
      }; 

      for (const key in this.dataChart[this.select2][this.select1]) {
        const element = this.dataChart[this.select2][this.select1][key];
        for (let i = 0; i < element.length; i++) {
          const el = element[i];
          Phase[key].push(el);
        }
        // Phase.push(element);
      }
      console.log(Phase);
      this.chart.series = [];
      this.chart.series.push({
        name: "Phase 1",
        data: Phase.Phase_1,
        tooltip: {
          valueDecimals: 2,
        },
      });
      this.chart.series.push({
        name: "Phase 2",
        data: Phase.Phase_2,
        tooltip: {
          valueDecimals: 2,
        },
      });
      this.chart.series.push({
        name: "Phase 3",
        data: Phase.Phase_3,
        tooltip: {
          valueDecimals: 2,
        },
      });
      // this.chart.series = [
      //   {
      //     name: "Phase 1",
      //     data: Phase[0],
      //     tooltip: {
      //       valueDecimals: 2,
      //     },
      //   },
      //   {
      //     name: "Phase 2",
      //     data: Phase[1],
      //     tooltip: {
      //       valueDecimals: 2,
      //     },
      //   },
      //   {
      //     name: "Phase 3",
      //     data: Phase[2],
      //     tooltip: {
      //       valueDecimals: 2,
      //     },
      //   },
      // ];

      // console.log(this.um_month_phase_1,this.um_year_phase_1);
    },
  },
};
</script>

<style>
</style>